import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createLabourItem } from '../api/labourItemsApi.ts';
import type { CreateLabourItemRequest } from '../types/labourItemTypes.ts';
import { labourItemsKeys } from '../../sites/hooks/useLabourItemsQuery.ts';
import { plotDetailsKeys } from '../../sites/hooks/usePlotDetails.ts';
import { plotsKeys } from '../../sites/hooks/usePlotsQuery.ts';

/**
 * Mutation hook for creating labour items.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export const useCreateLabourItem = (siteId: number, plotId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateLabourItemRequest) =>
      createLabourItem(siteId, plotId, data),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: labourItemsKeys.lists() });
      queryClient.invalidateQueries({ queryKey: plotDetailsKeys.details() });
      queryClient.invalidateQueries({ queryKey: plotsKeys.lists() });
    },
  });
};
